import { Modal as ModalContainer } from 'react-bootstrap';
import { BsFillCloudArrowUpFill } from 'react-icons/bs';
import { FileExcelOutlined } from '@ant-design/icons';

interface UploadModalProps{
    setFile: React.Dispatch<React.SetStateAction<Blob | undefined>>;
    isShowing: boolean;
    toggle: () => void;
    action: (() => void) | (() => Promise<void>)
}

export function UploadModal({ setFile, isShowing, toggle, action } : UploadModalProps) {
    return (
        <ModalContainer show={isShowing} onHide={toggle} className='modal-lg'>
            <ModalContainer.Header>
                <div className='modal-custom-header'>
                    <FileExcelOutlined className='icon-size-modal' />
                    <h3>
                        <strong>
                            Upload de Excel
                        </strong>
                    </h3>
                    <p>Selecione um arquivo .xlsx para realizar o upload dos dados</p>
                </div>
            </ModalContainer.Header>
            <ModalContainer.Body>
                <input type="file" onChange={(e) => e.target.files && setFile(e.target.files[0])} className='form-control' />
                <button className='btn btn-success mt-3' type='button' onClick={action}>
                    <BsFillCloudArrowUpFill className='me-2' size={20} />
                    Carregar documento
                </button>
            </ModalContainer.Body>
        </ModalContainer >
    )
}